// [MCV-1814] Inviting a provider, inviting a colleague and requesting a peer
// reference all answer a second request to the same email, while the first is
// still pending, with the same 409 and nothing created or sent:
//   { detail, extra: { code: 'PENDING_REQUEST_EXISTS', existingId } }
// The dialog then asks whether to resend the pending one.

export const PENDING_REQUEST_EXISTS = 'PENDING_REQUEST_EXISTS';

type ConflictShapedError = {
  response?: {
    status?: number;
    data?: { extra?: { code?: unknown; existingId?: unknown } };
  };
};

/**
 * The pending request a 409 points at, or null when `error` is anything else
 * (another status, another 409 code, a malformed body, not an axios error).
 */
export function getPendingRequestConflict(error: unknown): { existingId: number } | null {
  if (error == null || typeof error !== 'object' || !('response' in error)) return null;
  const response = (error as ConflictShapedError).response;
  if (response?.status !== 409) return null;
  const extra = response.data?.extra;
  if (extra?.code !== PENDING_REQUEST_EXISTS) return null;
  const { existingId } = extra;
  return typeof existingId === 'number' && Number.isInteger(existingId) ? { existingId } : null;
}
